import Service from "../service";

const ViewAPI = {
  getPlantDetail(plant_id) {
    return Service.get(`/api/views/` + plant_id);
  },
  getPlantList(data) {
    return Service.get(`/api/views`, {
      params: {
        page: data.page,
        knowledges_id: data.knowledges_id,
        categories_id: data.categories_id,
        community_id: data.community_id,
        keyword: data.keyword,
      },
    });
  },
  getOverview() {
    return Service.get(`/api/overview`);
  },
  getViewPlantByName(name){
    return Service.get(`/api/viewPlantByName`, {
      params: {
        name: name,
      },
    });
  }
};

export default ViewAPI;
